<script lang="ts">
  import { cn } from '../lib/cn';

  /** One placeholder block; size it with classes. LoadingState and page skeletons are built from it. */
  let { class: className }: { class?: string } = $props();
</script>

<div class={cn('skeleton h-4 w-full', className)} aria-hidden="true"></div>
